import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ITrainingRecord } from "../../../message-models/training-record.interface";
import { Router } from "@angular/router";
import { ITrainingRecordSummary } from '../../../message-models/training-record-summary.interface';
import { IAllowedOperations } from "../../../users/models/userInfo.interface";
import { ExportExcelService } from "../../../common/services/export-excel.service";
import { DatePipe } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { ITrainingType } from '../../../message-models/training-record-type.interface';

@Component({
  selector: 'app-operative-training-records',
  templateUrl: './operative-training-records.component.html',
  styleUrls: ['./operative-training-records.component.scss']
})

export class OperativeTrainingRecordsComponent implements OnInit {
  @Input() trainingRecords: Array<ITrainingRecordSummary> = new Array<ITrainingRecordSummary>();
  @Input() allowedOperations: IAllowedOperations;
  @Input() addButtonText = 'Add';
  @Input() showRowControllerButtons: boolean;
  @Input() totalCPDHours: number;
  @Input() trainingTypes: ITrainingType[] = [];
  @Output() addNewTrainingClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteTrainingRecordClicked: EventEmitter<ITrainingRecord> = new EventEmitter<ITrainingRecord>();
  @Output() trainingRecordId: EventEmitter<string> = new EventEmitter<string>();
  @Output() addObservationClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() addDocumentClicked: EventEmitter<ITrainingRecord> = new EventEmitter<ITrainingRecord>();
  isOnMobile = false;
  columns: any[];
  exportColumns: any[];
  rowMenuItems: MenuItem[];
  trainingRecordsSummariesToExport: any[] = [];

  constructor(private router: Router, private datePipe: DatePipe,
    private exportExcelService: ExportExcelService) { }

  ngOnInit(): void {
    this.isOnMobile = window.outerWidth <= 480;

    this.columns = [
      { field: 'achievedOn', header: 'Achieved On', type: 'date' },
      { field: 'validTo', header: 'Valid To', type: 'date' },
      { field: 'trainingTypeName', header: 'Training Course', type: 'text' },
      { field: 'trainingExtraDescription', header: 'Description', type: 'html' },
      { field: 'categoryName', header: 'Category Name', type: 'text' },
      { field: 'totalObservations', header: 'Observations', type: 'text' },
      
      { field: 'cpdHour', header: 'CPD Hours', type: 'text' }
    ];
    this.exportColumns = [

      { field: 'trainingTypeName', header: 'Training Course' },
      { field: 'achievedOn', header: 'Achieved On' },
      { field: 'validTo', header: 'Valid To' },
      { field: 'trainingExtraDescription', header: 'Description' },
      { field: 'categoryName', header: 'Category Name', type: 'text' },
      { field: 'totalObservations', header: 'Observations' },

      { field: 'cpdHour', header: 'CPD Hours' }
    ];

    this.rowMenuItems = [
      {
        label: 'Add Observation',
        icon: 'fas fa-eye',
        visible: this.showRowControllerButtons,
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.addObservation($event)
      },
      {
        label: 'Add Document',
        icon: 'fas fa-books',
        visible: this.showRowControllerButtons,
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.addDocument($event)
      },
      {
        label: 'Remove',
        icon: 'fas fa-trash-alt',
        styleClass: 'eca-menu-item-red',
        command: ($event) => this.deleteTrainingRecordRequested($event)
      }
    ]
  }

  addTrainingRecord() {
    this.addNewTrainingClicked.emit();
  }

  viewTrainingRecord(trainingRecord: ITrainingRecord) {
    if (!trainingRecord?.id)
      return;

    this.router.navigate(["/training-record/" + trainingRecord.id]);
  }

  exportToExcel() {
    this.trainingRecordsSummariesToExport = [];
    this.trainingRecords.forEach(element => {

      let temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = element.trainingExtraDescription;
      const tempObject = {
        achievedOn: this.datePipe.transform(element.achievedOn?.dateTime, 'dd/MM/yyyy'),
        validTo: this.datePipe.transform(element.validTo?.dateTime, 'dd/MM/yyyy'),
        trainingTypeName: element.trainingTypeName,
        trainingExtraDescription: temporalDivElement.textContent || temporalDivElement.innerText || "",
        categoryName: element.categoryName,
        totalObservations: element.totalObservations,
       
        cpdHour: element.cpdHour
      };
      this.trainingRecordsSummariesToExport.push(tempObject);
    });

    this.exportExcelService.exportToExcel(this.trainingRecordsSummariesToExport, this.exportColumns, 'OperativeTrainingRecords')
  }
  addObservation(trainingRecord: ITrainingRecord) {
    this.addObservationClicked.emit(trainingRecord.id);
  }
  addDocument(trainingRecord: ITrainingRecord) {
    this.addDocumentClicked.emit(trainingRecord);
  }
  deleteTrainingRecordRequested(trainingRecord: ITrainingRecord) {
    this.deleteTrainingRecordClicked.emit(trainingRecord);
  }
}
